import React, { useEffect, useState } from "react";

export default function SuggestionSugPage() {
    const [items, setItems] = useState([]);
    console.log('items',items)
    useEffect(() => {
        fetch("/api/suggestion_sugs")
            .then(res => res.json())
            .then(data => setItems(data["hydra:member"] || []))
            .catch(err => console.error(err));
    }, []);

    return (
        <div>
            <h1>Suggestions</h1>
            {items.length > 0 ? (
                <table border="1" cellPadding="5" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>SugId</th>
                            <th>SugDate</th>
                            <th>SugTerme</th>
                            <th>DomId</th>
                            <th>SugDom</th>
                            <th>StaId</th>
                            {/*<th>SugDefinition</th>
                              <th>SugCommentaire</th>*/}
                            <th>SugEqEtr</th>
                            <th>ComId</th>
                            <th>SugVALEUR</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {items.map((c) => (
                        <tr key={c.sugId}>
                            <td>{c.sugId}</td>
                            <td>{new Date(c.sugDate).toLocaleDateString("fr-FR")}</td>
                            <td>{c.sugTerme}</td>
                            <td>{c.domId}</td>
                            <td>{c.sugDom}</td>
                            <td>{c.staId}</td>
                            {/*<td>{c.sugDefinition}</td>
            <td>{c.sugCommentaire}</td>*/}
                            <td>{c.sugEqEtr}</td>
                            <td>{c.comId}</td>
                            <td>{c.sugVALEUR}</td>

                            <td>
                                {/*<button className="fr-btn" onClick={() => onEdit(c)}>Modifier</button>
                                <button className="fr-btn fr-btn--secondary" onClick={() => handleDelete(c.sugId)}>Supprimer</button>*/}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            ) : (
                <p>Aucune suggestion trouvée.</p>
            )}
        </div>
    );
}
